import { render } from "./MsColorPicker.vue?vue&type=template&id=02c5489a&scoped=true"
import script from "./MsColorPicker.vue?vue&type=script&lang=js"
export * from "./MsColorPicker.vue?vue&type=script&lang=js"

import "./MsColorPicker.vue?vue&type=style&index=0&id=02c5489a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c5489a"]])

export default __exports__